export const entries = [
	{
		'id': 'aB-zKTDZjDINyCLqhgdMK',
		'type': 'repository',
		'fakeId': 'aB-zKTDZjDINyCLqhgdMK',
		'parentId': null,
		'createdAt': '2026-02-28T12:33:57.177Z',
		'title': 'Work items',
		'singular': 'Work item',
		'rank': 0,
		'color': '#FFD93D',
		'isBookmarked': true
	},
	{
		'id': '-CPX86SrlnffwRzvpNgOq',
		'type': 'templatePropertyString',
		'fakeId': '-CPX86SrlnffwRzvpNgOq',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-02-28T12:33:57.576Z',
		'label': 'Do',
		'slug': 'do',
		'required': true,
		'rank': 0
	},
	{
		'id': 'BaqRIjCusvFCahrQXJUWX',
		'type': 'templatePropertyText',
		'fakeId': 'BaqRIjCusvFCahrQXJUWX',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-04-09T10:59:38.117Z',
		'label': 'Notes',
		'slug': 'additional-notes',
		'required': false,
		'rank': 8
	},
	{
		'id': 'WQsZN24NG0FywPKlpcHU4',
		'type': 'templatePropertyDate',
		'fakeId': 'WQsZN24NG0FywPKlpcHU4',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-04-03T17:49:53.914Z',
		'label': 'Created at',
		'slug': 'created-at',
		'required': true,
		'rank': 7
	},
	{
		'id': '4CyekONzSuI33jhX4ZNtO',
		'type': 'templatePropertyBelongsTo',
		'fakeId': '4CyekONzSuI33jhX4ZNtO',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-03-19T13:31:25.021Z',
		'label': 'Type',
		'slug': 'type',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'required': true,
		'allowMany': false,
		'rank': 1
	},
	{
		'id': 'n6umKbiRaVdZmeovJhd2A',
		'type': 'templatePropertyBelongsTo',
		'fakeId': 'n6umKbiRaVdZmeovJhd2A',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-04-26T13:12:57.174Z',
		'label': 'Category',
		'slug': 'category',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'required': false,
		'allowMany': false,
		'rank': 4
	},
	{
		'id': '331Xn2Ka-Od7-_68wFuUH',
		'type': 'repository',
		'fakeId': '331Xn2Ka-Od7-_68wFuUH',
		'parentId': null,
		'createdAt': '2026-03-19T13:29:50.881Z',
		'title': 'Item types',
		'singular': 'Item type',
		'rank': 1,
		'color': null,
		'isBookmarked': false
	},
	{
		'id': '5tYMZ0xb7g87YKDAlZhcs',
		'type': 'templatePropertyString',
		'fakeId': '5tYMZ0xb7g87YKDAlZhcs',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'createdAt': '2026-03-19T13:29:50.928Z',
		'label': 'Name',
		'slug': 'name',
		'required': false,
		'rank': null
	},
	{
		'id': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'templatePropertyString',
		'fakeId': 'mDkM_1ceVGEmAypsHaIXC',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'createdAt': '2026-04-02T09:42:44.802Z',
		'label': 'Description',
		'slug': 'description',
		'required': false,
		'rank': null
	},
	{
		'id': '9hhm_4uVcAH6Ee4MTdOPi',
		'type': 'repository',
		'fakeId': '9hhm_4uVcAH6Ee4MTdOPi',
		'parentId': null,
		'createdAt': '2026-02-28T12:33:57.177Z',
		'title': 'Daily journal',
		'singular': 'Journal entry',
		'rank': 3,
		'color': '#6BCB77',
		'isBookmarked': true
	},
	{
		'id': 'kATI9Xf5DINOzNzVqu--e',
		'type': 'templatePropertyString',
		'fakeId': 'kATI9Xf5DINOzNzVqu--e',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'createdAt': '2026-03-02T10:53:11.525Z',
		'label': ' Goal',
		'slug': 'goal',
		'required': true,
		'rank': 1
	},
	{
		'id': '5cp907OwvuNteGFgSQ-x1',
		'type': 'templatePropertyText',
		'fakeId': '5cp907OwvuNteGFgSQ-x1',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'createdAt': '2026-04-03T11:51:02.601Z',
		'label': 'Notes',
		'slug': 'notes1',
		'required': false,
		'rank': 3
	},
	{
		'id': 'secRcYa1ibIY_9IYlI5lj',
		'type': 'templatePropertyDate',
		'fakeId': 'secRcYa1ibIY_9IYlI5lj',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'createdAt': '2026-03-16T16:49:28.342Z',
		'label': 'Day',
		'slug': 'day',
		'required': true,
		'rank': 0
	},
	{
		'id': '8U446QKVEjtPFBeGDMVfu',
		'type': 'templatePropertyBelongsTo',
		'fakeId': '8U446QKVEjtPFBeGDMVfu',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'createdAt': '2026-03-02T10:52:16.066Z',
		'label': 'Work items',
		'slug': 'work-items',
		'targetRepositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'required': false,
		'allowMany': true,
		'rank': 2
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'MM4PaUbjACqaR8uQSAB2S',
		'fakeId': 'MM4PaUbjACqaR8uQSAB2S',
		'rank': 'a0'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'MM4PaUbjACqaR8uQSAB2S',
		'value': '🐞 Bug',
		'id': 'JV4rMDhQGQbW3ibQvp-Fz',
		'fakeId': 'JV4rMDhQGQbW3ibQvp-Fz'
	},
	{
		'id': 'geg-qOCWjoSskQhNU72FS',
		'type': 'repository',
		'fakeId': 'geg-qOCWjoSskQhNU72FS',
		'parentId': null,
		'createdAt': '2026-04-26T13:12:00.455Z',
		'title': 'Item categories',
		'singular': 'Item category',
		'rank': 2,
		'color': null,
		'isBookmarked': false
	},
	{
		'id': '67ji6o1Bl7DMLFxmNw0JC',
		'type': 'templatePropertyString',
		'fakeId': '67ji6o1Bl7DMLFxmNw0JC',
		'parentId': 'geg-qOCWjoSskQhNU72FS',
		'createdAt': '2026-04-26T13:12:00.680Z',
		'label': 'Name',
		'slug': 'name',
		'required': false,
		'rank': null
	},
	{
		'type': 'repositoryEntry',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'id': 'p5HqYsab89Fquc5w1A147',
		'fakeId': 'p5HqYsab89Fquc5w1A147',
		'rank': 'a0'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': 'secRcYa1ibIY_9IYlI5lj',
		'slug': 'day',
		'parentId': 'p5HqYsab89Fquc5w1A147',
		'value': '2026-04-28',
		'id': 'S7eLddU6TcNUPKPKE1DWe',
		'fakeId': 'S7eLddU6TcNUPKPKE1DWe'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': 'kATI9Xf5DINOzNzVqu--e',
		'slug': 'goal',
		'parentId': 'p5HqYsab89Fquc5w1A147',
		'value': 'Fix bugs at list view',
		'id': '9XsDCwVVk6o0blZfC8JoE',
		'fakeId': '9XsDCwVVk6o0blZfC8JoE'
	},
	{
		'parentId': 'p5HqYsab89Fquc5w1A147',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': '5cp907OwvuNteGFgSQ-x1',
		'type': 'entryPropertyText',
		'slug': 'notes1',
		'value': '',
		'id': 'IhmMSPAX0JsFR8G2Sztm3',
		'fakeId': 'IhmMSPAX0JsFR8G2Sztm3'
	},
	{
		'type': 'templatePropertyHas',
		'label': 'Worked on',
		'slug': 'worked-on',
		'targetRepositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'targetPropertySlug': 'work-items',
		'required': false,
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 2,
		'id': 'uCfkzOcAP0xYVgBhwxPF9',
		'fakeId': 'uCfkzOcAP0xYVgBhwxPF9'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'ImW3OpNTVFWadnV3Mh3X5',
		'fakeId': 'ImW3OpNTVFWadnV3Mh3X5',
		'rank': 'a2'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'ImW3OpNTVFWadnV3Mh3X5',
		'value': '💎 Feature',
		'id': 'u3J7eoZ7TLulkQRsuzdP_',
		'fakeId': 'u3J7eoZ7TLulkQRsuzdP_'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'D0ygDBEeuwCgfN8wctWOS',
		'fakeId': 'D0ygDBEeuwCgfN8wctWOS',
		'rank': 'a3'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'D0ygDBEeuwCgfN8wctWOS',
		'value': '✨ UX improvement',
		'id': 'gccmWs5Y0CD64W1sOesyu',
		'fakeId': 'gccmWs5Y0CD64W1sOesyu'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'eOzYkc1LjQmlpogD4fA4w',
		'fakeId': 'eOzYkc1LjQmlpogD4fA4w',
		'rank': 'a1'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'eOzYkc1LjQmlpogD4fA4w',
		'value': '🪖 Chore',
		'id': 'I-cRo1HJYKWSB2g_T7ODP',
		'fakeId': 'I-cRo1HJYKWSB2g_T7ODP'
	},
	{
		'parentId': 'D0ygDBEeuwCgfN8wctWOS',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Adjust the look and feel of an existing user flow',
		'id': 'DdA11iSNJbc_nOySCvjX-',
		'fakeId': 'DdA11iSNJbc_nOySCvjX-'
	},
	{
		'parentId': 'MM4PaUbjACqaR8uQSAB2S',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Unintended product behaviour impacting end user experience',
		'id': 'rcKJ-dZmboC7pSdTXD_vx',
		'fakeId': 'rcKJ-dZmboC7pSdTXD_vx'
	},
	{
		'parentId': 'eOzYkc1LjQmlpogD4fA4w',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Work that pays off in the long run. Prevent UX degradation. Mitigate risks.',
		'id': 'YyedOCfC8RrtkA9gaDCrG',
		'fakeId': 'YyedOCfC8RrtkA9gaDCrG'
	},
	{
		'parentId': 'ImW3OpNTVFWadnV3Mh3X5',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Unlocking new user flows',
		'id': 'lNeSjLOHqLHfTp0Ih3i4a',
		'fakeId': 'lNeSjLOHqLHfTp0Ih3i4a'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'ZYeamVHPDew48audwhnwF',
		'fakeId': 'ZYeamVHPDew48audwhnwF',
		'rank': 'a4'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'ZYeamVHPDew48audwhnwF',
		'value': '💡 Idea',
		'id': 'ue5DvCWJxzIRqe6d5oH3K',
		'fakeId': 'ue5DvCWJxzIRqe6d5oH3K'
	},
	{
		'parentId': 'ZYeamVHPDew48audwhnwF',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Needs more research',
		'id': '63XTWBhIt4NuQe5Ma_QmW',
		'fakeId': '63XTWBhIt4NuQe5Ma_QmW'
	},
	{
		'type': 'templatePropertyText',
		'label': 'Description',
		'slug': 'description',
		'required': false,
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 3,
		'id': 'yXP_M8uPIqErWfGQSDfyJ',
		'fakeId': 'yXP_M8uPIqErWfGQSDfyJ'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': '_5jm9oLpxt2WphWqscCVH',
		'fakeId': '_5jm9oLpxt2WphWqscCVH',
		'rank': 'Zy'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': '_5jm9oLpxt2WphWqscCVH',
		'value': 'Show total items count at list view',
		'id': 'Lit7nk0S1lw1RIlo8FD8H',
		'fakeId': 'Lit7nk0S1lw1RIlo8FD8H'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': '_5jm9oLpxt2WphWqscCVH',
		'value': 'D0ygDBEeuwCgfN8wctWOS',
		'id': '0hHhTv8NeW2cYU9wFHsKr',
		'fakeId': '0hHhTv8NeW2cYU9wFHsKr',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': '_5jm9oLpxt2WphWqscCVH',
		'value': '2026-04-27',
		'id': 'Nm_Ro0rq77AS8QkeldR_y',
		'fakeId': 'Nm_Ro0rq77AS8QkeldR_y'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'fakeId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'rank': 'a0',
		'isArchived': true
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'value': 'Entries list can’t handle long titles on mobile',
		'id': 'hQ0f0OZOLLXHBNJx1aOgc',
		'fakeId': 'hQ0f0OZOLLXHBNJx1aOgc'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'value': 'MM4PaUbjACqaR8uQSAB2S',
		'id': 'jZDKiMx11xxwVajsKh8HD',
		'fakeId': 'jZDKiMx11xxwVajsKh8HD',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'value': '2026-04-27',
		'id': 'LtgYHpt-AEinPu4HLnwDN',
		'fakeId': 'LtgYHpt-AEinPu4HLnwDN'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'fakeId': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'rank': 'Zz',
		'isArchived': false
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'value': 'Query builder to list view',
		'id': 'Y9am-hYtR9DNc29AXC-Zg',
		'fakeId': 'Y9am-hYtR9DNc29AXC-Zg'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'value': 'ImW3OpNTVFWadnV3Mh3X5',
		'id': 'hjFWgCl_e1jE-2YLFTT6S',
		'fakeId': 'hjFWgCl_e1jE-2YLFTT6S',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'value': '2026-04-27',
		'id': 'IhW5nnYxinevjvPf18x_2',
		'fakeId': 'IhW5nnYxinevjvPf18x_2'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'ngMZQbo-rStZMnCnPRcxO',
		'fakeId': 'ngMZQbo-rStZMnCnPRcxO',
		'rank': 'Zv'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'ngMZQbo-rStZMnCnPRcxO',
		'value': 'Add lazy loading to the list view',
		'id': 'Q8V-7byY_At2k1sL2dtAD',
		'fakeId': 'Q8V-7byY_At2k1sL2dtAD'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'ngMZQbo-rStZMnCnPRcxO',
		'value': 'eOzYkc1LjQmlpogD4fA4w',
		'id': 'XA2DrpT1BkbsJ_T4NliNq',
		'fakeId': 'XA2DrpT1BkbsJ_T4NliNq',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'ngMZQbo-rStZMnCnPRcxO',
		'value': '2026-04-27',
		'id': '6v05JS9W6LGXg11jM7nzJ',
		'fakeId': '6v05JS9W6LGXg11jM7nzJ'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'geg-qOCWjoSskQhNU72FS',
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'id': 'WuWAdIgZ_yFXcJaZtZkMy',
		'fakeId': 'WuWAdIgZ_yFXcJaZtZkMy',
		'rank': 'a0'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'propertyDefinitionId': '67ji6o1Bl7DMLFxmNw0JC',
		'slug': 'name',
		'parentId': 'WuWAdIgZ_yFXcJaZtZkMy',
		'value': 'Collection list view',
		'id': 'k0zJjvxvFgGttR1srUi4p',
		'fakeId': 'k0zJjvxvFgGttR1srUi4p'
	},
	{
		'parentId': 'ngMZQbo-rStZMnCnPRcxO',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'WuWAdIgZ_yFXcJaZtZkMy',
		'id': 'tuAFWHqPJ50Kk8mKSfhon',
		'fakeId': 'tuAFWHqPJ50Kk8mKSfhon'
	},
	{
		'parentId': '_5jm9oLpxt2WphWqscCVH',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'WuWAdIgZ_yFXcJaZtZkMy',
		'id': 'JKtZTO2YOx7RXgjaH6mDU',
		'fakeId': 'JKtZTO2YOx7RXgjaH6mDU'
	},
	{
		'type': 'chart',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 1,
		'title': 'Items shipped / 1mo',
		'where': '{"shipped-date":{"start":{"relativeDays":-29},"end":{"relativeDays":0}}}',
		'includeArchived': true,
		'metric': '__count__',
		'xAxis': 'shipped-date',
		'xAxisTimeScale': null,
		'xy': {
			'x': 263.44799938325906,
			'y': -36.99290436725323
		},
		'id': 'kYSuNu_gaDWR-LKxeKY7h',
		'fakeId': 'kYSuNu_gaDWR-LKxeKY7h',
		'variant': 'heatmap',
		'targetA': null,
		'targetB': null
	},
	{
		'type': 'templatePropertyDate',
		'label': 'Shipped date',
		'slug': 'shipped-date',
		'required': false,
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 5,
		'id': 'WXumQcFO_lv8E73Pwy8Ri',
		'fakeId': 'WXumQcFO_lv8E73Pwy8Ri'
	},
	{
		'parentId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WXumQcFO_lv8E73Pwy8Ri',
		'type': 'entryPropertyDate',
		'slug': 'shipped-date',
		'value': '2026-04-29',
		'id': 'PSZOOxWvhwc65HS2GG7hm',
		'fakeId': 'PSZOOxWvhwc65HS2GG7hm'
	},
	{
		'parentId': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WXumQcFO_lv8E73Pwy8Ri',
		'type': 'entryPropertyDate',
		'slug': 'shipped-date',
		'value': '2026-04-29',
		'id': 'QoX4YXiufG5TXdbkQ37JL',
		'fakeId': 'QoX4YXiufG5TXdbkQ37JL'
	},
	{
		'parentId': '_5jm9oLpxt2WphWqscCVH',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WXumQcFO_lv8E73Pwy8Ri',
		'type': 'entryPropertyDate',
		'slug': 'shipped-date',
		'value': '2026-04-30',
		'id': 'a0Iul8wNCX8phkVMRC9Ez',
		'fakeId': 'a0Iul8wNCX8phkVMRC9Ez'
	},
	{
		'parentId': 'p5HqYsab89Fquc5w1A147',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': '8U446QKVEjtPFBeGDMVfu',
		'targetRepositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'slug': 'work-items',
		'value': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'id': 'pbnjAAUjqao6iP7pSF4q1',
		'fakeId': 'pbnjAAUjqao6iP7pSF4q1'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'id': 't7wW3vx0JTd1nb_7PLSXY',
		'fakeId': 't7wW3vx0JTd1nb_7PLSXY',
		'rank': 'Zz'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': 'secRcYa1ibIY_9IYlI5lj',
		'slug': 'day',
		'parentId': 't7wW3vx0JTd1nb_7PLSXY',
		'value': '2026-04-27',
		'id': 'tfuIci96SbOvRfGMVUUkJ',
		'fakeId': 'tfuIci96SbOvRfGMVUUkJ'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': 'kATI9Xf5DINOzNzVqu--e',
		'slug': 'goal',
		'parentId': 't7wW3vx0JTd1nb_7PLSXY',
		'value': 'Ship query builder',
		'id': 'VqWVdkucpLGo6Un-b8vV-',
		'fakeId': 'VqWVdkucpLGo6Un-b8vV-'
	},
	{
		'parentId': 't7wW3vx0JTd1nb_7PLSXY',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': '8U446QKVEjtPFBeGDMVfu',
		'targetRepositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'slug': 'work-items',
		'value': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'id': 'dQkeHvTtD_zr9SOhuYnDx',
		'fakeId': 'dQkeHvTtD_zr9SOhuYnDx'
	},
	{
		'parentId': 't7wW3vx0JTd1nb_7PLSXY',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': '8U446QKVEjtPFBeGDMVfu',
		'targetRepositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'slug': 'work-items',
		'value': '_5jm9oLpxt2WphWqscCVH',
		'id': 'rh2iaXl-Wed3YSb_BnaAF',
		'fakeId': 'rh2iaXl-Wed3YSb_BnaAF'
	},
	{
		'parentId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'WuWAdIgZ_yFXcJaZtZkMy',
		'id': 'gK8P9JamBxRIvOh-z7JsW',
		'fakeId': 'gK8P9JamBxRIvOh-z7JsW'
	},
	{
		'type': 'query',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 1,
		'title': 'Items left in the backlog',
		'where': '{"shipped-date":{"isUnset":true}}',
		'includeArchived': false,
		'xy': {
			'x': 262.22967295609607,
			'y': 92.34117074668177
		},
		'id': 'cTJmMfTiYa2FtNMWwIAkd',
		'fakeId': 'cTJmMfTiYa2FtNMWwIAkd'
	},
	{
		'type': 'repository',
		'title': 'Monthly checkin',
		'singular': 'Monthly checkin item',
		'parentId': null,
		'rank': 1,
		'id': 'tV2PAm2QcWnP0v6hL1d8-',
		'fakeId': 'tV2PAm2QcWnP0v6hL1d8-',
		'isBookmarked': true,
		'color': '#4D96FF'
	},
	{
		'type': 'templatePropertyDate',
		'label': 'Date',
		'slug': 'date',
		'required': true,
		'parentId': 'tV2PAm2QcWnP0v6hL1d8-',
		'rank': 0,
		'id': 'qpsEOPwwvrUdmftG5iOKD',
		'fakeId': 'qpsEOPwwvrUdmftG5iOKD'
	},
	{
		'type': 'templatePropertyNumber',
		'label': 'Tech dept in the backlog',
		'slug': 'tech-dept',
		'required': true,
		'parentId': 'tV2PAm2QcWnP0v6hL1d8-',
		'rank': 2,
		'id': '5zifAWVMy2rAP-s767B0u',
		'fakeId': '5zifAWVMy2rAP-s767B0u'
	},
	{
		'type': 'templatePropertyNumber',
		'label': 'Items delivered',
		'slug': 'items-delivered',
		'required': true,
		'parentId': 'tV2PAm2QcWnP0v6hL1d8-',
		'rank': 1,
		'id': '--LQhuyFUYTBO3_igT5lm',
		'fakeId': '--LQhuyFUYTBO3_igT5lm'
	},
	{
		'type': 'templatePropertyNumber',
		'label': 'Bugs in the backlog',
		'slug': 'bugs',
		'required': true,
		'parentId': 'tV2PAm2QcWnP0v6hL1d8-',
		'rank': 3,
		'id': '3rAZTMszjluqz3gyAa9G6',
		'fakeId': '3rAZTMszjluqz3gyAa9G6'
	},
	{
		'type': 'templatePropertyNumber',
		'label': 'Incidents',
		'slug': 'incidents',
		'required': true,
		'parentId': 'tV2PAm2QcWnP0v6hL1d8-',
		'rank': 4,
		'id': 'Y1cHIltTp29iZFu00iwbC',
		'fakeId': 'Y1cHIltTp29iZFu00iwbC'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'tV2PAm2QcWnP0v6hL1d8-',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'id': 'Ij7sEcWV2eXEt_ZOOW7DS',
		'fakeId': 'Ij7sEcWV2eXEt_ZOOW7DS',
		'rank': 'a1'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': 'qpsEOPwwvrUdmftG5iOKD',
		'slug': 'date',
		'parentId': 'Ij7sEcWV2eXEt_ZOOW7DS',
		'value': '2026-04-24',
		'id': 'ZkbaYZuGAU4cK-S-GYvYz',
		'fakeId': 'ZkbaYZuGAU4cK-S-GYvYz'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '--LQhuyFUYTBO3_igT5lm',
		'slug': 'items-delivered',
		'parentId': 'Ij7sEcWV2eXEt_ZOOW7DS',
		'value': '13',
		'id': 'rFa6KWxigDi8oSppFVN2D',
		'fakeId': 'rFa6KWxigDi8oSppFVN2D'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '5zifAWVMy2rAP-s767B0u',
		'slug': 'tech-dept',
		'parentId': 'Ij7sEcWV2eXEt_ZOOW7DS',
		'value': '4',
		'id': '757QNQApB53Jcc4xEhyz4',
		'fakeId': '757QNQApB53Jcc4xEhyz4'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '3rAZTMszjluqz3gyAa9G6',
		'slug': 'bugs',
		'parentId': 'Ij7sEcWV2eXEt_ZOOW7DS',
		'value': '4',
		'id': 'o-qTsKbN9tqOp5ZlkTgcn',
		'fakeId': 'o-qTsKbN9tqOp5ZlkTgcn'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': 'Y1cHIltTp29iZFu00iwbC',
		'slug': 'incidents',
		'parentId': 'Ij7sEcWV2eXEt_ZOOW7DS',
		'value': 2,
		'id': 'CMSeeat06fYxLRVQ_PRhh',
		'fakeId': 'CMSeeat06fYxLRVQ_PRhh'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'tV2PAm2QcWnP0v6hL1d8-',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'id': 'PkN-zqr_xv-2nFNJj3DNy',
		'fakeId': 'PkN-zqr_xv-2nFNJj3DNy',
		'rank': 'a0'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': 'qpsEOPwwvrUdmftG5iOKD',
		'slug': 'date',
		'parentId': 'PkN-zqr_xv-2nFNJj3DNy',
		'value': '2026-03-27',
		'id': 'eLzIxK1r1FrXrtDGOqEBL',
		'fakeId': 'eLzIxK1r1FrXrtDGOqEBL'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '--LQhuyFUYTBO3_igT5lm',
		'slug': 'items-delivered',
		'parentId': 'PkN-zqr_xv-2nFNJj3DNy',
		'value': '15',
		'id': 'QAzhW_BrU4RBO4jDiGVoL',
		'fakeId': 'QAzhW_BrU4RBO4jDiGVoL'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '5zifAWVMy2rAP-s767B0u',
		'slug': 'tech-dept',
		'parentId': 'PkN-zqr_xv-2nFNJj3DNy',
		'value': '5',
		'id': 'aVH4Jcylv9E6PDft691Sg',
		'fakeId': 'aVH4Jcylv9E6PDft691Sg'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '3rAZTMszjluqz3gyAa9G6',
		'slug': 'bugs',
		'parentId': 'PkN-zqr_xv-2nFNJj3DNy',
		'value': '3',
		'id': 'kSUHRhNDh_ezdTqNSDEQ2',
		'fakeId': 'kSUHRhNDh_ezdTqNSDEQ2'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': 'Y1cHIltTp29iZFu00iwbC',
		'slug': 'incidents',
		'parentId': 'PkN-zqr_xv-2nFNJj3DNy',
		'value': '1',
		'id': 'Z3wICSynQaTtx5SfYbVV0',
		'fakeId': 'Z3wICSynQaTtx5SfYbVV0'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'tV2PAm2QcWnP0v6hL1d8-',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'id': 'tuhADlKa22C27I4Vr3dFY',
		'fakeId': 'tuhADlKa22C27I4Vr3dFY',
		'rank': 'a2'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': 'qpsEOPwwvrUdmftG5iOKD',
		'slug': 'date',
		'parentId': 'tuhADlKa22C27I4Vr3dFY',
		'value': '2026-02-27',
		'id': '_wWsKIRcTqTTxYIp9HcvH',
		'fakeId': '_wWsKIRcTqTTxYIp9HcvH'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '--LQhuyFUYTBO3_igT5lm',
		'slug': 'items-delivered',
		'parentId': 'tuhADlKa22C27I4Vr3dFY',
		'value': '20',
		'id': 'PPAMmpE_APwejL2u5FmJb',
		'fakeId': 'PPAMmpE_APwejL2u5FmJb'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '5zifAWVMy2rAP-s767B0u',
		'slug': 'tech-dept',
		'parentId': 'tuhADlKa22C27I4Vr3dFY',
		'value': 7,
		'id': 'xw07lZvu3tHbZTd7o5JMP',
		'fakeId': 'xw07lZvu3tHbZTd7o5JMP'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '3rAZTMszjluqz3gyAa9G6',
		'slug': 'bugs',
		'parentId': 'tuhADlKa22C27I4Vr3dFY',
		'value': '7',
		'id': '57aiviTrU5rp-BI2_R0v8',
		'fakeId': '57aiviTrU5rp-BI2_R0v8'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': 'Y1cHIltTp29iZFu00iwbC',
		'slug': 'incidents',
		'parentId': 'tuhADlKa22C27I4Vr3dFY',
		'value': '0',
		'id': '97Mi9YI87aJmjjzE1RYNY',
		'fakeId': '97Mi9YI87aJmjjzE1RYNY'
	},
	{
		'type': 'chart',
		'parentId': null,
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'rank': 1,
		'title': 'Techical dept trend / 6mo',
		'where': '{"date":{"start":"2025-11-04","end":"2026-04-24"}}',
		'includeArchived': true,
		'metric': 'tech-dept',
		'xAxis': 'date',
		'xAxisTimeScale': 'M',
		'xy': {
			'x': -55.0827651832015,
			'y': -89.54726647461115
		},
		'id': '52ldlA5Mhure1jMNxhZfm',
		'fakeId': '52ldlA5Mhure1jMNxhZfm',
		'variant': 'line',
		'targetA': null,
		'targetB': null
	},
	{
		'type': 'chart',
		'parentId': null,
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'rank': 1,
		'title': 'Bugs trend / 6mo',
		'where': '{"date":{"start":"2025-11-04","end":"2026-04-24"}}',
		'includeArchived': true,
		'metric': 'bugs',
		'xAxis': 'date',
		'xAxisTimeScale': 'M',
		'xy': {
			'x': -56.55142085459465,
			'y': 71.48321495419935
		},
		'id': 'yDgvrVdbi7YYE5ayPY4G-',
		'fakeId': 'yDgvrVdbi7YYE5ayPY4G-',
		'variant': 'line',
		'targetA': null,
		'targetB': null
	},
	{
		'type': 'chart',
		'parentId': null,
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'rank': 1,
		'title': 'Items shipped trend / 6mo',
		'where': '{"date":{"start":"2025-11-04","end":"2026-04-24"}}',
		'includeArchived': true,
		'metric': 'items-delivered',
		'xAxis': 'date',
		'xAxisTimeScale': 'M',
		'xy': {
			'x': -57.05520423777182,
			'y': 233.87324174090952
		},
		'id': 'Or-yvI45DLUt3P92CpeV4',
		'fakeId': 'Or-yvI45DLUt3P92CpeV4',
		'variant': 'line',
		'targetA': null,
		'targetB': null
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'tV2PAm2QcWnP0v6hL1d8-',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'id': 'U_w1N4qFZ1MYQqvRybi5_',
		'fakeId': 'U_w1N4qFZ1MYQqvRybi5_',
		'rank': 'a3V'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': 'qpsEOPwwvrUdmftG5iOKD',
		'slug': 'date',
		'parentId': 'U_w1N4qFZ1MYQqvRybi5_',
		'value': '2025-12-25',
		'id': 'A2yW5QCRlg7-voqT3li8X',
		'fakeId': 'A2yW5QCRlg7-voqT3li8X'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '--LQhuyFUYTBO3_igT5lm',
		'slug': 'items-delivered',
		'parentId': 'U_w1N4qFZ1MYQqvRybi5_',
		'value': '10',
		'id': 'QdEjVvO4JDK9oSyFEoJ_E',
		'fakeId': 'QdEjVvO4JDK9oSyFEoJ_E'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '5zifAWVMy2rAP-s767B0u',
		'slug': 'tech-dept',
		'parentId': 'U_w1N4qFZ1MYQqvRybi5_',
		'value': '10',
		'id': 'Wo0aq-dNIzpmMB2fGF0bL',
		'fakeId': 'Wo0aq-dNIzpmMB2fGF0bL'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '3rAZTMszjluqz3gyAa9G6',
		'slug': 'bugs',
		'parentId': 'U_w1N4qFZ1MYQqvRybi5_',
		'value': '5',
		'id': 'EIQK5i-pwnNUQm76mpbkH',
		'fakeId': 'EIQK5i-pwnNUQm76mpbkH'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': 'Y1cHIltTp29iZFu00iwbC',
		'slug': 'incidents',
		'parentId': 'U_w1N4qFZ1MYQqvRybi5_',
		'value': '0',
		'id': 'lcYiQZvQr3aZlVn2tHWrY',
		'fakeId': 'lcYiQZvQr3aZlVn2tHWrY'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'tV2PAm2QcWnP0v6hL1d8-',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'id': '9l_AnCFD3Z0Bbdc6n3VMh',
		'fakeId': '9l_AnCFD3Z0Bbdc6n3VMh',
		'rank': 'a4'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': 'qpsEOPwwvrUdmftG5iOKD',
		'slug': 'date',
		'parentId': '9l_AnCFD3Z0Bbdc6n3VMh',
		'value': '2025-11-30',
		'id': 'rGFOjC2IDf9uI3Cv_OeoO',
		'fakeId': 'rGFOjC2IDf9uI3Cv_OeoO'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '--LQhuyFUYTBO3_igT5lm',
		'slug': 'items-delivered',
		'parentId': '9l_AnCFD3Z0Bbdc6n3VMh',
		'value': 15,
		'id': 'F7N93xIDlTo_Ix5VYU3dQ',
		'fakeId': 'F7N93xIDlTo_Ix5VYU3dQ'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '5zifAWVMy2rAP-s767B0u',
		'slug': 'tech-dept',
		'parentId': '9l_AnCFD3Z0Bbdc6n3VMh',
		'value': 10,
		'id': 'WWWtMjAonQdKteLxHqqTh',
		'fakeId': 'WWWtMjAonQdKteLxHqqTh'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '3rAZTMszjluqz3gyAa9G6',
		'slug': 'bugs',
		'parentId': '9l_AnCFD3Z0Bbdc6n3VMh',
		'value': '1',
		'id': 'Krk3tsrY6ja3FCa0_wm7F',
		'fakeId': 'Krk3tsrY6ja3FCa0_wm7F'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': 'Y1cHIltTp29iZFu00iwbC',
		'slug': 'incidents',
		'parentId': '9l_AnCFD3Z0Bbdc6n3VMh',
		'value': '1',
		'id': 'oebCQUKyRgiwW8Fg7RI67',
		'fakeId': 'oebCQUKyRgiwW8Fg7RI67'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'tV2PAm2QcWnP0v6hL1d8-',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'id': '74QofDe8LV6odPdmYMFWQ',
		'fakeId': '74QofDe8LV6odPdmYMFWQ',
		'rank': 'a3'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': 'qpsEOPwwvrUdmftG5iOKD',
		'slug': 'date',
		'parentId': '74QofDe8LV6odPdmYMFWQ',
		'value': '2026-01-30',
		'id': '9CknCOHcW6e3D5qXhwYdm',
		'fakeId': '9CknCOHcW6e3D5qXhwYdm'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '--LQhuyFUYTBO3_igT5lm',
		'slug': 'items-delivered',
		'parentId': '74QofDe8LV6odPdmYMFWQ',
		'value': 15,
		'id': 'qzgMQPPJfLWH49SNQAH7j',
		'fakeId': 'qzgMQPPJfLWH49SNQAH7j'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '5zifAWVMy2rAP-s767B0u',
		'slug': 'tech-dept',
		'parentId': '74QofDe8LV6odPdmYMFWQ',
		'value': 4,
		'id': 'WxaAM1aSo8j53CWVIfEmd',
		'fakeId': 'WxaAM1aSo8j53CWVIfEmd'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': '3rAZTMszjluqz3gyAa9G6',
		'slug': 'bugs',
		'parentId': '74QofDe8LV6odPdmYMFWQ',
		'value': '1',
		'id': '5NHqLlNtg1YDNL8aIISJL',
		'fakeId': '5NHqLlNtg1YDNL8aIISJL'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'propertyDefinitionId': 'Y1cHIltTp29iZFu00iwbC',
		'slug': 'incidents',
		'parentId': '74QofDe8LV6odPdmYMFWQ',
		'value': '1',
		'id': 'U-7FIemhX_lj4nLdB-D_q',
		'fakeId': 'U-7FIemhX_lj4nLdB-D_q'
	},
	{
		'type': 'templatePropertyText',
		'label': 'Comments',
		'slug': 'comments',
		'required': false,
		'parentId': 'tV2PAm2QcWnP0v6hL1d8-',
		'rank': 5,
		'id': 'EDsFkNU7KL8xLCo7WWzNy',
		'fakeId': 'EDsFkNU7KL8xLCo7WWzNy'
	},
	{
		'type': 'query',
		'parentId': null,
		'repositoryId': 'tV2PAm2QcWnP0v6hL1d8-',
		'rank': 3,
		'title': 'All monthly check-ins',
		'includeArchived': true,
		'xy': {
			'x': -61.34375,
			'y': 350.3828125
		},
		'id': 'bFYrahEBFSU1aamjc5Fp9',
		'fakeId': 'bFYrahEBFSU1aamjc5Fp9'
	}
];